module.exports = __webpack_public_path__ + "img/115.db990e16.jpg";